
{
  "actions": {
    "order": "Order Now"
  },
  "labels": {
    "title": "Have you heard about our free rewards program?",
    "subtitle": "Unlock delicious food by ordering directly from us."
  },
  "reasons": {
    "0": "Earn points with every order",
    "1": "Purchase food with points",
    "2": "Receive exclusive discounts"
  }
}
